import dayjs from 'dayjs'
import { useGetEstablishmentEntityEvolutionQuery } from '@/core/services/statistics'

type UseEntityEvolutionParams = {
  establishmentId: string
  dateRange: [Date, Date]
  isExpanded: boolean
}

/**
 * Hook to fetch entity evolution data for the statistics page
 * @param params - Parameters for fetching entity evolution
 * @returns Entity evolution data and loading state
 */
export function useEntityEvolution(params: UseEntityEvolutionParams) {
  const { establishmentId, dateRange, isExpanded } = params

  const { data, isLoading } = useGetEstablishmentEntityEvolutionQuery(
    {
      establishment: establishmentId,
      startDate: dayjs(dateRange[0]).format('YYYY-MM-DD'),
      endDate: dayjs(dateRange[1]).format('YYYY-MM-DD'),
    },
    {
      skip: !establishmentId || !isExpanded,
      refetchOnMountOrArgChange: true,
    }
  )

  return { data, isLoading }
}
